.input {
	inline-size: 100%;
	min-block-size: 2.5rem;
	padding: 0 var(--spacing-3);
	font-family: inherit;
	font-size: var(--font-size-base);
	color: var(--colour-text-primary);
	background-color: var(--colour-background-surface);
	border: 1px solid var(--colour-border-strong);
	border-radius: var(--radius-md);
	transition:
		border-color var(--motion-fast) var(--ease-standard),
		box-shadow var(--motion-fast) var(--ease-standard);

	&::placeholder {
		color: var(--colour-text-secondary);
	}

	&:hover {
		border-color: var(--colour-text-secondary);
	}

	&:focus-visible {
		outline: none;
		border-color: var(--colour-focus-ring);
		box-shadow: 0 0 0 3px color-mix(in srgb, var(--colour-focus-ring) 25%, transparent);
	}

	&:disabled {
		cursor: not-allowed;
		opacity: 0.5;
	}

	&[data-invalid] {
		border-color: var(--colour-danger);

		&:focus-visible {
			box-shadow: 0 0 0 3px color-mix(in srgb, var(--colour-danger) 25%, transparent);
		}
	}
}
